// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Transactions GetAll
/**
 *
 * @param {{params?: object, query?: {
 *   customerId?: string,
 *   saleId?: string,
 *   bankAccountId?: string,
 *   transactionType?: "Unknown" | "SaleInvoice" | "Transaction" | "Payment",
 *   onlyOpens?: boolean,
 *   page?: number,
 *   limit?: number
 * }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Transactions.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Transactions Get
/**
 *
 * @param {{params: object, query: { saleId: string, customerId: string  }}} option
 *
 * @returns
 */
export const GetUserPaidTransactionBalance = async (option) => {
  const response = await $api.get(
    Endpoints.Transactions.GetUserPaidTransactionBalance(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Transactions Create
/**
 *
 * @param {{
 *   customerId: string,
 *   saleId?: string,
 *   date: string,
 *   amount: number,
 *   bankAccountId: string,
 *   description?: string,
 *   transactionType?: "Unknown" | "SaleInvoice" | "Transaction" | "Payment",
 *   parasutAccountId?: string
 * }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Transactions.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Transactions Create
/**
 *
 * @param {{ "plainText": "string", "isFavourite": true, "saleId": "string", "userId": "string" }} form
 *
 * @returns
 */
export const AddTransactionToMikro = async (form) => {
  const response = await $api.post(
    Endpoints.Transactions.AddTransactionToMikro(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Transactions MatchPayment
/**
 * Müşteri ön ödemesini (tahsilat) belirli bir vade borcu (CustomerPayment) ile eşleştirir/kapatır.
 * @param {{ transactionId: string, customerPaymentId: string, amount: number, explainText?: string }} form
 * @returns
 */
export const MatchPayment = async (form) => {
  const response = await $api.post(
    Endpoints.Transactions.MatchPayment(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Transactions CancelTransaction
/**
 * Tahsilat işlemini iptal eder ve varsa bu tahsilatla kapatılmış borç vadesi eşleşmelerini geri alır.
 * @param {{params: { id: string }, query?: object}} option
 * @returns
 */
export const CancelTransaction = async (option) => {
  const response = await $api.post(
    Endpoints.Transactions.CancelTransaction(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Transactions Get ById
/**
 * Id'ye göre tahsilat bilgisini döner.
 * @param {{params: { id: string }, query?: object}} option
 * @returns {Promise<{
 *   message: string,
 *   data?: {
 *     id: string,
 *     saleId?: string | null,
 *     salePayments?: Array<{
 *       guid?: string,
 *       customerPaymentId?: string,
 *       amount?: number,
 *       paymentDate?: string,
 *       explainText?: string,
 *       saleId?: string | null
 *     }>
 *   }
 * }>}
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Transactions.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Transactions Update
/**
 *
 * @param {{ "plainText": "string", "isFavourite": true, "saleId": "string", "userId": "string", isActive: string }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Transactions.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Transactions Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Transactions.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  GetUserPaidTransactionBalance,
  Create,
  AddTransactionToMikro,
  MatchPayment,
  CancelTransaction,
  GetById,
  Update,
  Delete,
};
